<lib-modal-base
  [visible]="isOpen()"
  [title]="isCredentialRevoke() ? ('revoke-credential' | translate) : ('company-revoke' | translate)"
  [size]="'large'"
  (handleClose)="onClose()"
>
  <div class="modal-content">
    @if (isCredentialRevoke()) {
      <p class="warning-text">
        {{ 'revoke-credential-confirm' | translate }}
      </p>

      <div class="request-summary">
        <lib-badge
          [label]="credentialType()!"
          [colorScheme]="badgeColor"
        />
      </div>

      <div class="warning-box">
        <i-feather name="alert-triangle" class="warning-icon"></i-feather>
        <p>{{ 'revoke-credential-detail' | translate: { credentialType: credentialType() } }}</p>
      </div>
    } @else {
      <p class="warning-text">
        {{ 'company-revoke-warning' | translate }}
      </p>

      <div class="request-summary">
        <span class="company-label">{{ companyName() }}</span>
      </div>

      <div class="warning-box">
        <i-feather name="alert-triangle" class="warning-icon"></i-feather>
        <p>{{ 'company-revoke-credential-warning' | translate }}</p>
      </div>
    }

    <div class="button-group">
      <lib-button
        variant="text"
        (clicked)="onClose()"
        [disabled]="isLoading()"
      >
        {{ 'cancel' | translate }}
      </lib-button>
      <lib-button
        variant="contained"
        color="danger"
        (clicked)="onConfirm()"
        [isLoading]="isLoading()"
      >
        {{ 'confirm' | translate }}
      </lib-button>
    </div>
  </div>
</lib-modal-base>
